// extracted by mini-css-extract-plugin
export default {"input":"stripe-payment-form_input__axJWV","stripe-btns":"stripe-payment-form_stripe-btns__A2v1f"};